import React from 'react';
import { Switch, Route, useRouteMatch } from 'react-router-dom';
import { Pages } from "components/pages";

export default function СollectionsRoute() {

    const { path } = useRouteMatch();

    return (
        <Switch>
            <Route path={ `${ path }` } exact>
                <Pages.Collections />
            </Route>
            <Route path={ `${ path }/page/:pageNum` } exact>
                <Pages.Collections />
            </Route>
            <Route path={ `${ path }/page` } exact>
                <Pages.Collections />
            </Route>
            <Route path={ `${ path }/:id` } >
                { ({ match, history }) => <Pages.Collection match={ match } history={ history } exact /> }
            </Route>
        </Switch>
    );
}

